(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bisou-recommendations-reveal')) {
    customElements.define(
      'bisou-recommendations-reveal',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.revealInitialized === 'true') return;

          this.dataset.revealInitialized = 'true';

          if (
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            !('IntersectionObserver' in window)
          ) {
            this.classList.add('is-revealed');
            return;
          }

          this.classList.add('is-reveal-ready');
          this.revealObserver = new IntersectionObserver(
            ([entry]) => {
              if (!entry?.isIntersecting) return;

              this.classList.add('is-revealed');
              this.revealObserver?.disconnect();
              this.revealObserver = null;
            },
            { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
          );
          this.revealObserver.observe(this);
        }

        disconnectedCallback() {
          this.revealObserver?.disconnect();
          this.revealObserver = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
